import { TbX } from 'react-icons/tb';
import type { IconProps } from './IconBase';
import { IconBase } from './IconBase';

export const XIcon = (props: IconProps) => {
  return <IconBase icon={TbX} {...props} />;
};
